export default class extends HTMLElement {
  connectedCallback () {
    this.id = `menu-active-${Math.random().toString(32).split('.')[1]}`

    for (const link of [...this.querySelectorAll('a')].reverse()) {
      if (document.location.pathname.startsWith(link.dataset.path || link.pathname) && !link.getAttribute('href').startsWith('http')) {
        link.classList.add(...(this.dataset.activeClass ? this.dataset.activeClass.split(' ') : ['bg-base-300']))

        if (this.dataset.scrollIntoView) {
          const list = link.closest('.overflow-y-auto')

          if (list) {
            const listRect = list.getBoundingClientRect()
            const linkRect = link.getBoundingClientRect()

            list.scrollTop += linkRect.top - listRect.top - (list.clientHeight - linkRect.height) / 2
          } else {
            link.scrollIntoView({ block: 'nearest', inline: 'nearest' })
          }
        }

        break
      }
    }
  }
}
